import React from 'react';

const NavDivider = () => <li className="separator" />;
export default NavDivider;
